module.exports = __webpack_public_path__ + "img/28_63.e301c282.png";